import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  staffComponentRoles: any = {
    company: 'Full Access',
    accountant: 'Accountant',
    credential: 'Credentialer',
    mdispatcher: 'Dispatch Manager',
    dispatcher: 'Dispatcher',
    mcallcenter: 'Call Center Manager',
    rcallcenter: 'Call Center Representative'
  }

  accountStatus: any = {
    active: 'Active',
    inactive: 'InActive',
  }

  fleetAccountStatus = {
    active: 'Active',
    inactive: 'InActive',
  }

  driverComponentProfileRoles = {
    driver: 'Driver',
    dispatcher: 'Dispatcher'
  }

  constructor(
    private http: HttpClient
  ) { }

  signin(payload: any): Observable<any> {
    return this.http.post<any>(urls.API_URL + urls.SIGNIN_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getToken(key: any) {
    try {
      const token = localStorage.getItem(key);
      return token ? JSON.parse(token) : '';
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }

  setToken(key: any, token: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(token));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  removeToken(key: any): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }
}
